import ReactDOM from 'react-dom';
import {Nelar} from './Nelar';
import {swrConfig as SWRConfig} from './swrConfig';


ReactDOM.render(
    <SWRConfig >
      <Nelar />
    </ SWRConfig>,
    document.getElementById('root'),
);
